import React, { Component } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useState, useEffect } from "react";
import { addScreenshotsTop, addScreenshotsBottom, setFormScreenshot, setCalledFrom } from '../store/slices/DocumentClaimSlice';
import { useSelector,shallowEqual } from 'react-redux';
import { useDispatch } from 'react-redux';




const CopyPaste = (props) => {
  




    const [imageDataURL, setImageDataURL] = useState(null);
    const [blob, setBlob] = useState(false);


   
    const onPaste = (event) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;
        for (let i = 0; i<items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                if(items[i].type==="image/png")
                {const imageFile = items[i].getAsFile();
                processImage(imageFile);
                }
                else{
                    if(props.alertRef.current)
                        props.alertRef.current.showSnackbar("Please upload a screenshot in PNG format", "error");
                }
            }
        }
    };

    const processImage = (imageFile) => {
        const objectUrl = URL.createObjectURL(imageFile); //create img temp url
        // console.log("image file",imageFile)
        const image = new Image();//create html img into memo
        image.onload = () => {//if img loads successfully 
            URL.revokeObjectURL(objectUrl);//clean up memory
            const reader = new FileReader();//reads base 64 str
            reader.onload = (event) => {//runs when file successfully reads
            const result = event.target.result;//extracting data
            if (typeof result === 'string' && result.startsWith("data:image/png;base64,")) {
                props.updateValueAtIndex(result, props.id);
                setImageDataURL(result);//no use
            } else {
                if(props.alertRef.current)
                    props.alertRef.current.showSnackbar("Please upload a valid image. This image seems to be corrupted.", "error");
                    }
                };
            reader.readAsDataURL(imageFile);//pass an imgFile to readAsDataURL,browser reads async,when read successfull on load trig
        };
        image.onerror = () => {//if img corrupted
            URL.revokeObjectURL(objectUrl);
            if(props.alertRef.current)
                props.alertRef.current.showSnackbar("Please upload a valid image. This image seems to be corrupted.", "error");
        };
        image.src = objectUrl;//loading the image from the temporary URL, which triggers either onload or onerror.
    };

    

    const [isClicked,setIsClicked] = useState(false);

    const handlePinch=(e)=>{
        e.preventDefault();
    }

    return (

        <div key={props.id} id={`id-${props.id}`} className='container' style={props.calledFrom==="docClaim"?{display:'block',padding:"0%"}:{display:'block'}}>
          {(props.maxVersion===props.versionSelected||props.maxVersion.value===props.versionSelected.value)?
            <div
            onClick={()=>setIsClicked(true)}
                className='paste-container'
                ref={(ref) => {
                    if (ref) {
                        ref.addEventListener('paste', onPaste);
                    }
                }}
            >
            {props.url===undefined?<div>
                {isClicked?<div><label className="colorBlueFontBold">Control-V</label> to paste an image</div>:<div><label className="colorBlueFontBold">Click here</label> to paste an image</div>}
                </div>:''}
            </div>

 :""} 

            <div draggable={false} >

                <TransformWrapper
                
                onPinching={handlePinch}
                wheel={{disabled:true}}
                >
                    {({ zoomIn, zoomOut, resetTransform }) => (
                        <React.Fragment>
                            {props.url!==undefined?
                                 <div className="tools">
                                 <span className="marginLeft10" title="Zoom Out" onClick={() => zoomIn()}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
  <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
  <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
</svg></span>

                                <span className="marginLeft10" title="Zoom In" onClick={() => zoomOut()}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-out" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
  <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
  <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
</svg></span>


                                <span className="marginLeft10" title="Resize" onClick={() => resetTransform()}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-aspect-ratio-fill" viewBox="0 0 16 16">
  <path d="M0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5M2.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1zm11 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0V11h-2.5a.5.5 0 0 0 0 1z"/>
</svg></span>
{(props.maxVersion===props.versionSelected||props.maxVersion.value===props.versionSelected.value)?
      <span className="marginLeft10" title="Add Screenshot" onClick={() => {props.handleAdd(); setIsClicked(false);}}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0"/>
    </svg></span>:''}
                            </div>
                            :""} 
                           {(props.maxVersion===props.versionSelected||props.maxVersion.value===props.versionSelected.value)?

                            <div draggable={true} onDragStart={(e)=>props.dragScrnshot(e,props.id)} onDragOver={props.handleDragOverScrnshot} onDrop={(e)=>props.dropScrnshot(e,props.id)} className="copyPasteDivContainer">
                            <div className="rightSide">
                            <TransformComponent >
                                <div className='pasted-image' style={{minHeight:'100%'}} >
                               {props.url && <img src={props.url}  />} 
                                </div>
                            </TransformComponent >
                            </div>
                            <div className="leftSide">
                            {props.url!==undefined? 
                            <span title="drag'n'drop">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-horizontal" viewBox="0 0 16 16">
  <path d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
</svg>
                            </span>
                            :''}
                            </div>
                           </div>

                           : 
                          <TransformComponent >
                                 <div className='pasted-image' style={{minHeight:'100%'}} >
                                    {props.url && <img src={props.url}  />} 
                                </div>

                         </TransformComponent>
                          } 
                        </React.Fragment>
                    )}
                </TransformWrapper>
            </div>

        </div>
        // </div>

    );
};
export default CopyPaste